;(function() {
  let cards = [].slice.call(document.querySelectorAll('[data-card-lender-row]'))

  cards.forEach(element => {
    let showMoreButton = element.querySelector('[data-show-more]')
    let bullets = [].slice.call(element.querySelectorAll('[data-bullet-item]'))
    let newBullets = bullets.slice(3)

    displayBullets(newBullets)

    if (showMoreButton) {
      showMoreButton.addEventListener('click', () => {
        changeText(showMoreButton)
        displayBullets(newBullets)
      })
    }

    function displayBullets(elm) {
      elm.forEach(item => {
        item.classList.contains('+display-none')
          ? item.classList.remove('+display-none')
          : item.classList.add('+display-none')
      })
    }

    function changeText(button) {
      button.innerText =
        button.innerText == '+ Show More' ? '- Show Less' : '+ Show More'
    }
  })
})()
